import React, { useEffect, useState } from "react";
import { createdPass } from "../../../../services/OrderService";
import { postPaymentMethodByAdmin, postPaymentMethodStatus, UpdatePass, updateUserDetail, uploadAvatar } from "../../../../services/UserService";
import { ActiveType } from "../../../../models/Login";
import { ImageInputData } from "../../../hooks/useImageUploadInput";
import useAlertDialog from "../../../hooks/useAlertDialog";
import { AlertType } from "../../../hooks/common/useAttachAlertDialog";

export default function useUpdatePaymentMethodStatus(props: { setLoading: (val: boolean) => void; reload: () => void }) {
	const { openAlertDialog } = useAlertDialog();
	const doUpdate = async (id: number, status: number) => {
		props.setLoading(true)

		try {
			await postPaymentMethodStatus(id, status);
			openAlertDialog?.(AlertType.Success, "Thay đổi thành công!", () => {
				props.setLoading(false);
				props.reload();
			});
		} catch (err: any) {
			console.error(err);
			openAlertDialog?.(AlertType.Fail, err?.response.data?.message || "An error has occurred!", () => {
				props.setLoading(false);
			});
		}
	};

	return {
		doUpdate,
	};
}
